import { FC } from 'react';

import InfoSection, {
  IInfoSectionProps,
} from '@/components/common/InfoPanels/InfoSection';

const SuccessInfoPanel: FC<Omit<IInfoSectionProps, 'variant'>> = (props) => (
  <InfoSection variant={'success'} {...props} />
);

export default SuccessInfoPanel;
